export const SET_EOC_REPORT = 'SET_EOC_REPORT';

export const setEocReport = (reportPayload) => ({
  type: SET_EOC_REPORT,
  payload: reportPayload,
});
